import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../StyleSheet/AppComponent/SideBar/SideBar.scss";
import { Link, useLocation } from "react-router-dom";
import { getsidebarActions } from "../../../Redux/Slice";
import home from "../../../Assets/AppComponent/Logo/Home.svg";
import scheduled from "../../../Assets/AppComponent/Logo/Scheduled.svg";
import send from "../../../Assets/AppComponent/Logo/Send.svg";
import home_white from "../../../Assets/AppComponent/Logo/Home_white.svg";
import scheduled_white from "../../../Assets/AppComponent/Logo/Scheduled_white.svg";
import send_white from "../../../Assets/AppComponent/Logo/Send_white.svg";
import userCreate from "../../../Assets/AppComponent/Logo/createUser.svg";
import userCreate_white from "../../../Assets/AppComponent/Logo/createUser_white.svg";
import createPlantProject from "../../../Assets/AppComponent/Logo/createPlantProject.svg";
import createPlantProject_white from "../../../Assets/AppComponent/Logo/createPlantProject_white.svg";
import invoiceDashboard from "../../../Assets/AppComponent/Images/invoiceDash.svg";
import DshboarInvoiceWhit from "../../../Assets/AppComponent/Images/DshboarInvoiceWhit.svg";
import emailDash from "../../../Assets/AppComponent/Images/emailDash.svg";
import EmailDashWhite from "../../../Assets/AppComponent/Images/EmailDashWhite.svg";
import visualize_orange from "../../../Assets/AppComponent/Images/visualize_orange.svg";
import visualize_white from "../../../Assets/AppComponent/Images/visualize_white.svg";

const SideBar = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const userData = useSelector((state) => state.users.UserData.data);
  const Active = false;
  const location = useLocation();
  const dispatch = useDispatch();
  const [isShown, setIsShown] = useState({});
  useEffect(() => {
    console.log(userData, "sdkljakjlsdjklasdkjaskjl");
  }, []);

  const SideBarMap = [
    {
      id: 1,
      label: "MAIL DASHBOARD",
      icon: emailDash,
      hrefLink: "/",
      altHref: ["/create_schedule"],
      changeIcon: EmailDashWhite,
    },

    // {
    //   id: 3,
    //   label: "MAIL HISTORY",
    //   icon: send,
    //   hrefLink: "/sent",

    //   changeIcon: send_white,
    // },
  ];

  // if (userData.role === "admin") {
  if (userData.role === "admin") {
    SideBarMap.push(
      {
        id: 6,
        label: "INVOICE DASHBOARD",
        icon: invoiceDashboard,
        hrefLink: "/dashBoard",
        altHref: ["/dashBoard"],
        changeIcon: DshboarInvoiceWhit,
      },
      {
        id: 7,
        label: "PLANT-SUMMARY",
        icon: visualize_orange,
        hrefLink: "/graphs",
        altHref: [`/graphs/`],
        changeIcon: visualize_white,
      },
      {
        id: 2,
        label: "SCHEDULED",
        icon: scheduled,
        hrefLink: "/scheduled/",
        changeIcon: scheduled_white,
      },

      {
        id: 4,
        label: "CREATE USER",
        icon: userCreate,
        hrefLink: "/createUser",
        altHref: ["/createuserform"],
        changeIcon: userCreate_white,
      },
      {
        id: 5,
        label: "PLANT & PROJECT",
        icon: createPlantProject,
        hrefLink: "/plantProject",
        altHref: [`/projects/`, "/projectWps/"],
        changeIcon: createPlantProject_white,
      }
    );
  } else {
    SideBarMap.push({
      id: 2,
      label: "SCHEDULED",
      icon: scheduled,
      hrefLink: "/scheduled/",
      changeIcon: scheduled_white,
    });
  }
  const handleMouseEnter = () => {
    // if (stateDisplay) {
    dispatch(getsidebarActions(Active));
    // }
    // setEntereds(true);
  };
  const handleMouseExit = () => {
    // setEntereds(false);

    // if (setEntereds && !stateDisplay) {
    dispatch(getsidebarActions(!Active));
    // }
  };
  // useEffect(() => {
  //   //console.log(stateDisplay, "stateDisplaystateDisplaystateDisplay");
  // }, [stateDisplay]);

  return (
    <>
      <div
        className={stateDisplay ? "sidebarclose" : "sidebar"}
        id="sidebar"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseExit}
      >
        <div className="">
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              {/* <ul className="SideBarsUl">
                {SideBarMap.map((item) => (
                  <li
                    key={item.id}
                    className={
                      (isShown[item.id] && item.changeIcon) ||
                      location.pathname === item.hrefLink ||
                      item?.altHref?.includes(location.pathname)
                        ? "active"
                        : ""
                    }
                    onMouseEnter={() => setIsShown({ id: true })}
                    onMouseLeave={() => setIsShown({ id: false })}
                  >
                    <Link to={item.hrefLink}>
                      <img
                        src={
                          (isShown[item.id] && item.changeIcon) ||
                          location.pathname === item.hrefLink ||
                          item?.altHref?.includes(location.pathname)
                            ? item.changeIcon
                            : item.icon
                        }
                        alt={item.hrefLink}
                        width={"25px"}
                        height={"25px"}
                      />
                      <span className={stateDisplay ? "test" : "sideToggle"}>
                        {item.label}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul> */}
              <ul className="SideBarsUl">
                {SideBarMap.map((item) => (
                  <li
                    key={item.id}
                    className={
                      (isShown[item.id] && item.changeIcon) ||
                      location.pathname === item.hrefLink ||
                      (item.altHref &&
                        item.altHref.some((altLink) =>
                          location.pathname.includes(altLink)
                        ))
                        ? "active"
                        : ""
                    }
                    onMouseEnter={() => setIsShown({ id: true })}
                    onMouseLeave={() => setIsShown({ id: false })}
                  >
                    <Link to={item.hrefLink}>
                      <img
                        src={
                          (isShown[item.id] && item.changeIcon) ||
                          location.pathname === item.hrefLink ||
                          (item.altHref &&
                            item.altHref.some((altLink) =>
                              location.pathname.includes(altLink)
                            ))
                            ? item.changeIcon
                            : item.icon
                        }
                        alt={item.hrefLink}
                        width={"25px"}
                        height={"25px"}
                      />
                      <span className={stateDisplay ? "test" : "sideToggle"}>
                        {item.label}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
